export default __webpack_public_path__ + "static/media/NTEX SYLLABUS_2026-27 CLASS 8.430ab0a5.pdf";